"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        drawer: {
            '& .MuiBackdrop-root': {
                backgroundColor: 'rgba(0,0,0,.10)',
            },
        },
        title: {
            color: themes_1.materialColors.blue[900],
            fontSize: '13px',
        },
        controls: {
            position: 'sticky',
            backgroundColor: 'white',
            bottom: 0,
            left: 0,
            right: 0,
        },
    });
});
